import { ChangeEvent, FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MainLayout from '../../components/MainLayout'
import PageBodyLayout from '../../components/PageBodyLayout'
import { AppDispatch } from '../../store'
import { deselectCase, getArchivedReports } from '../../store/reports/reportsSlice'
import ArchivePageDataPart from './ArchivePageDataPart'
import FilterPart from './FilterPart'
import { useForm } from 'react-hook-form'
import { IGenericObjectStringValue } from '../../types'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { filterReports, sortedData } from '../../utils'
import useDebounce from '../../hooks/useDebounce'
import useAutoLogout from '../../hooks/useAutoLogout'

const ArchivePage: FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [searchValue, setSearchValue] = useState<string>('')
  const debouncedSearched = useDebounce(searchValue, 500)
  const autoLogout = useAutoLogout()

  const archivedReports = useSelector(reportsSelectors.addressedAndResolved)
  const loading = useSelector(reportsSelectors.addressedAndResolvedLoading)

  const formMethods = useForm<IGenericObjectStringValue>({
    defaultValues: { sortBy: 'mostRecent', jumpTo: '' },
    mode: 'onChange',
    shouldFocusError: false,
  })
  const { control, watch } = formMethods

  const sortByWatchValue = watch('sortBy')
  const jumpToWatchValue = watch('jumpTo')

  useEffect(() => {
    dispatch(deselectCase({ value: undefined }))
  }, [])

  useEffect(() => {
    dispatch(getArchivedReports())
  }, [])

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setSearchValue(event.target.value)
  }

  return (
    <MainLayout>
      <PageBodyLayout
        className={'t-archive-page'}
        filterPart={
          <FilterPart
            sortByWatchValue={sortByWatchValue}
            jumpToWatchValue={jumpToWatchValue}
            control={control}
            handleSearchChange={handleSearchChange}
            searchValue={searchValue}
          />
        }
        dataPart={
          <ArchivePageDataPart
            archivedReports={sortedData(
              filterReports(archivedReports, debouncedSearched),
              sortByWatchValue,
            )}
            loading={loading}
          />
        }
      />
    </MainLayout>
  )
}

export default ArchivePage
